export default [
    {
        path: '',
        name: 'pageComissionerRouter',
        component: () => import('./page-comissioner')
    }
]